import { InitiativesService } from './../../../../@core/utils/initiatives.service';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NbAccordionModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogRef, NbDialogService, NbSpinnerModule } from '@nebular/theme';
import { KPI } from '../../../../@core/api';
import { BaseSelectableListComponent } from '../base-selectable-list/base-selectable-list.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { first, Observable } from 'rxjs';
import { ThousandsSeparatorPipe } from '../../../pipes';
import { SideFormDialogComponent } from '../side-form-dialog/side-form-dialog.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-initiatives-selectable-list',
  standalone: true,
  imports: [
    CommonModule,
    NbCardModule,
    TranslateModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbAccordionModule,
    NbButtonModule,
    ThousandsSeparatorPipe,
    FormsModule,
  ],
  templateUrl: './initiatives-selectable-list.component.html',
  styleUrl: '../base-form/base-form.component.scss',
})
export class InitiativesSelectableListComponent extends BaseSelectableListComponent<KPI.MappedInitiative> {

  @Input() public perimeter: KPI.Perimeter;
  @Input() public startYear: number;
  @Input() public endYear: number;
  @Input() public title = this.translate.instant('Initiatives');
  @Input() public removeHypothesis = false;

  constructor(
    protected nbDialogRef: NbDialogRef<InitiativesSelectableListComponent>,
    protected dialogService: NbDialogService,
    private initiativesService: InitiativesService,
    private translate: TranslateService,
  ) {
    super(nbDialogRef, dialogService);
  }

  protected getAllElements$(): Observable<KPI.MappedInitiative[]> {
    return this.initiativesService.getInitiatives(
      [this.perimeter]
    ).pipe(first());
  }

  protected showInNotLinkedElements(_element: KPI.MappedInitiative): boolean {
    return true
  }

  public getInitiativeSavings(initiative: KPI.MappedInitiative): number {
    return initiative.gains.map(gain => gain.theoretical_savings_full_year).reduce((a, b) => a + b, 0);
  }

  public isInPeriod(initiative: KPI.MappedInitiative): boolean {
    const initiativeYear = new Date(initiative.savings_start_at).getFullYear();
    return initiativeYear <= this.endYear && initiativeYear >= this.startYear;
  }

  public notLinkedElementChecked(element: KPI.MappedInitiative): void {
    if (!this.isInPeriod(element)) {
      this.dialogService.open(
        SideFormDialogComponent,
        {
          autoFocus: false,
          context: {
            title: this.translate.instant('Dates consistency'),
            content: this.translate.instant('The action date does not match the bouquet of works period'),
            canCancel: false,
          },
        },
      )
    }
  }
  
}
